import { usePortalName } from './usePortalName';

export function useImageBase(): string {
  const portalName = usePortalName();
  return portalName ? `/${portalName}` : '';
}
